import React from 'react';
import ReactDOM from 'react-dom';
import SelectAccountMode from '../screens/parent/select-account-mode';
// global css loaded
import '../../css/dist/select-account-type.scss';


const App = () => {
    return <SelectAccountMode/>
}

ReactDOM.render(<App/>, document.getElementById('select-account-type'))